

import { Component, Prop } from 'vue-property-decorator'
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from 'chart.js'

import Base from "../../../core/components/Base.vue";
import { getMonthsArray } from '../../tools/booking.stats.tools';
import { SlotStats } from '../../model/statistics/SlotStats';


ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement)


@Component({
  components: { LineChartGenerator }
})
export default class BarLineComboChart extends Base {


  get statistics() {
    return this.$store.state.booking.bookingStatistics;
  }

  @Prop({ default: 'bar-line-combo-chart' }) chartId!: string

  @Prop({ default: 'label' }) datasetIdKey!: string

  @Prop({ default: 50 }) width!: number

  @Prop({ default: 25 }) height!: number

  @Prop({ default: 'full-size' }) cssClasses!: string

  @Prop() plugins!: unknown[]

  @Prop() chartOptions!: unknown[]

  styles = {
    display: "block",
    margin: "0 auto",
  }

  barChartConfig = {
    labels: getMonthsArray(),
    datasets: [
      {
        type: 'bar',
        label: 'réservations',
        data:
          this.getMonthsDataReduced(Object.values(this.statistics.monthly), 'totalBooking')
        ,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
        ],
        borderColor: [
        ],
        barPercentage: 1,
        categoryPercentage: 0.5

      },
      {
        type: 'line',
        label: 'noShows',
        data:
          this.getMonthsDataReduced(Object.values(this.statistics.monthly), 'validBooking', 'completedBooking'),
        backgroundColor: [
          'rgba(220, 53, 69, 0.7)',
        ],
        fill: false,
        pointBorderWidth: 0,
        pointStyle: 'rectRot',
        pointRadius: 4,
      },
    ]

  }

  options = {
    responsive: true,
    plugins: {
      tooltip: {
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 16
        },
        footerFont: {
          size: 14
        },
        boxPadding: 10,
        padding: 12,
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          font: {
            size: 16
          },
        }
      }
    },
    scales: {
      y: {
        display: true,
        ticks: {
          display: true,
          stepSize: 20,
        },
        grid: {
          drawOnChartArea: false,
          drawTicks: true,
        },
        scaleLabel: { display: false },
        title: {
          display: true,
          text: 'Nb réservations',
          font: {
            size: 11
          }
        }
      },
      x: {
        ticks: {
          font: {
            size: 12
          }
        }
      }
    }
  }

  getMonthDataReduced(monthData: SlotStats[], statReq: string) {
    return monthData.reduce((sum: number, currentMonth: SlotStats) => {
      return sum + currentMonth[statReq]
    }, 0)
  }

  getMonthsDataReduced(monthsData: SlotStats[][], statReq: string, statReq2?: string) {
    const array: number[] = []
    monthsData.forEach((monthData: SlotStats[]) => {
      if (statReq2) {
        return (array.push(this.getMonthDataReduced(monthData, 'validBooking') - this.getMonthDataReduced(monthData, 'completedBooking')))
      }
      return array.push(this.getMonthDataReduced(monthData, statReq))
    })
    return array.reverse()
  }
}

